import { configureStore } from '@reduxjs/toolkit';

import * as reducers from 'common/state';
import { UPDATE_FILTER } from '../../trends/company/constants/ActionTypes';
import { COACHING_SESSION_FILE_DELETE_ERROR } from '../state/coachingSession';


export const getAppStoreConfiguration = (...middlewares) => {
  return {
    reducer: reducers,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          // we put moment objects in stores for filter values like start date and end date
          ignoredActions: [UPDATE_FILTER, COACHING_SESSION_FILE_DELETE_ERROR],
        },
      }).concat(...middlewares),
  };
};
/*
This module was being loaded by 2 separate packs on the same page.
This resulted in code using the legacy reactInterop dispatching actions to the wrong pack.
As a quick fix, we're just using window.store if it's already there.
(As we move towards an SPA this will cease to be necessary.)
*/

function getStore() {
  return configureStore(getAppStoreConfiguration());
}

if (!window.store) {
  window.store = getStore();
}

declare global {
  interface Window {
    store: ReturnType<typeof getStore>;
  }
}

export default window.store;
